import { css } from '@emotion/react';

import { breakpoints } from '@coursera/cds-common';

const getContentCss = css`
  padding: 0 var(--cds-spacing-200);

  ${breakpoints.up('sm')} {
    padding: 0 var(--cds-spacing-400);
  }

  ${breakpoints.up('md')} {
    padding: 0 var(--cds-spacing-600);
  }
`;

export default getContentCss;
